import React from 'react';

import { flagStyles } from '../settings';

const SvgLC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3024px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLC;
